module.exports = __webpack_public_path__ + "static/media/DecIdBack.barclays.63bc8041.tsx";